module.exports = __webpack_public_path__ + "static/media/book-backward.f347a3a9.png";